const STEPS = {
  SCHEDULE_DEACTIVATION: 'scheduleDeactivation',
  CONFIRMATION_THANKS: 'confirmationThanks',
  CONFIRMATION: 'confirmation',
  CONFIRMATION_HAS_ERROR: 'confirmationHasError',
};

const RADIO_OPTIONS = {
  FOUND_RENTER_ON_ZILLOW: {
    displayLabel: 'Found a new renter through Zillow',
    modalHeader: 'Thanks for choosing Zillow!',
    step: STEPS.CONFIRMATION_THANKS,
    reason: 'foundRenterOnZillow',
  },
  FOUND_RENTER_ELSEWHERE: {
    displayLabel: 'Found a new renter elsewhere',
    modalHeader: 'Thanks for choosing Zillow!',
    step: STEPS.CONFIRMATION_THANKS,
    reason: 'foundRenterElsewhere',
  },
  STILL_LOOKING_PAUSING_ON_ZILLOW: {
    displayLabel: 'Still looking for a renter, but pausing this Zillow listing',
    modalHeader: 'Thanks for choosing Zillow!',
    step: STEPS.CONFIRMATION_THANKS,
    reason: 'stillLookingPausingOnZillow',
  },
  HAS_ERROR: {
    displayLabel: "There's an error with the listing that I need to resolve",
    modalHeader: 'How to fix listing errors',
    step: STEPS.CONFIRMATION_HAS_ERROR,
    reason: 'errorWithListing',
  },
};

export { STEPS, RADIO_OPTIONS };
